import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UNAUTHORIZED, NOT_FOUND, FORBIDDEN } from 'http-status-codes';
import { eventEmitter } from '@app/shared/utils/event-emitter';

import { AuthenticationService } from '@app/core/services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private injector: Injector
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === NOT_FOUND) {
        this.router.navigate(['/404']);
        return;
      }

      if (err.status === UNAUTHORIZED) {
        const currentTenant = this.authenticationService.currentTenant;
        // Gọi refresh token
        return this.authenticationService.refreshToken(currentTenant.refresh_token).pipe(
          switchMap((data) => {

            // Tạo request bị lỗi với token mới
            const retryRequest = request.clone({
              setHeaders: {
                Authorization: `${data.token_type} ${data.token}`,
              },
            });

            // Gọi lại request
            return next.handle(retryRequest);
          }),
          catchError(refreshError => {
            // Nếu thất bại -> refresh token hết hạn -> logout
            this.authenticationService.logout();
            location.href = '/auth/login';
            return throwError(refreshError);
          })
        );
      }

      if (err.status === FORBIDDEN) {
        this.router.navigate(['/']);
        return;
      }
      const message = this.authenticationService.getMessageError(err.error);
      const messageService = this.injector.get(NzMessageService);
      if (message) {
        messageService.create('error', message);
      } else {
        if(err.error.error == "invalid_grant")
        {
           messageService.create('error', 'Tên đăng nhập hoặc mật khẩu không chính xác !');
        }
        else
        {
          messageService.create('error', 'Có lỗi trong quá trình thao tác vui lòng kiểm tra lại !')
        }
      }
      eventEmitter.emit('haserror', {error: true});
      return throwError({
        status: err.status,
        error: err.error
      });
    }));
  }
}
